const getLocaleForPath = locale => (locale === 'en' ? '' : `/${locale}`);

export const updateURL = (locale, routes) => {
  const { origin } = window.location;
  const destination = routes[locale];

  window.location = destination
    ? `${origin}${getLocaleForPath(locale)}${routes[locale]}`
    : `${origin}/404`;
};

export default {
  updateURL
};
